import { useMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import { nuc } from '../../../../utils';
import type { CheckRevisionResponse } from '../../../../../shared/revisions/types';

const checkRevision = async (revisionLocator: string) => {
  const resp = await post<unknown, CheckRevisionResponse>(`/api/revisions/${nuc(revisionLocator)}/check`, {});
  return resp.data;
};

/**
 * Hook for checking if a revision is likely to resolve when added as a dependency.
 */
export default function useCheckRevision() {
  return useMutation<string, CheckRevisionResponse | undefined>({
    mutationFn: async (revisionLocator: string) => checkRevision(revisionLocator),
  });
}
